import { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useAuth } from '@/contexts/auth-context'
import { useAuthActions } from '@convex-dev/auth/react'
import { useNavigate } from 'react-router-dom'
import { isElectron } from '@/lib/electron'

import { Navbar } from '@/components/homepage/sections/Navbar'
import { SectionHeader } from '@/components/homepage/ui/SectionHeader'
import { HomepageFooter } from '@/components/homepage/sections/HomepageFooter'
import termsHtml from './terms-content.html?raw'
import { OG_IMAGE_URL, siteUrl } from '@/lib/config/site'

export default function TermsPage() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const { signIn } = useAuthActions()
  const handleSignUp = () => {
    if (isElectron()) {
      navigate('/signup')
      return
    }
    signIn('google', { redirectTo: `${window.location.origin}/auth` })
  }

  useEffect(() => { window.scrollTo(0, 0) }, [])

  return (
    <div className="min-h-screen bg-background px-4 lg:px-0 overflow-x-hidden">
      <Helmet>
        <title>Terms of Service - Footage</title>
        <meta name="description" content="Terms of Service for Footage.com." />
        <link rel="canonical" href={siteUrl('/terms')} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Terms of Service - Footage" />
        <meta property="og:description" content="Terms of Service for Footage.com." />
        <meta property="og:url" content={siteUrl('/terms')} />
        <meta property="og:image" content={OG_IMAGE_URL} />
        <meta property="og:site_name" content="Footage" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms of Service - Footage" />
        <meta name="twitter:description" content="Terms of Service for Footage.com." />
        <meta name="twitter:image" content={OG_IMAGE_URL} />
      </Helmet>

      <div className="max-w-7xl mx-auto border-x border-border">
        <Navbar isAuthenticated={isAuthenticated} onSignUp={handleSignUp} />
        <main className="flex flex-col divide-y divide-border pt-16">
          <SectionHeader>
            <div className="flex flex-col items-center justify-center gap-4 mt-4">
              <h1 className="text-3xl md:text-4xl lg:text-6xl font-medium tracking-tighter text-center text-balance">
                Terms of Service
              </h1>
              <p className="text-muted-foreground md:text-lg text-center">
                Last Updated: January 14, 2026
              </p>
            </div>
          </SectionHeader>

          <section className="px-6 md:px-12 lg:px-20 py-12 md:py-16">
            <div className="max-w-3xl mx-auto prose prose-neutral dark:prose-invert">
              <div
                className="legal-content"
                dangerouslySetInnerHTML={{ __html: termsHtml }}
              />
            </div>
          </section>

          <HomepageFooter />
        </main>
      </div>
    </div>
  )
}
